export const state = {
	paymentMethods: [],
	clientSecret: null
}



// WEBPACK FOOTER //
// ./src/common/store/PaymentMethod/state.js